export function toFloat(value, nbDigits=2, invalid=0) {
  value = parseFloat(value);
  return (isNaN(value) || value == null)
    ? invalid
    : parseFloat(value.toFixed(nbDigits));
}

export function nullMultiply(value, multiplicator) {
  return (value == null || isNaN(parseFloat(value)))
    ? null
    : value * multiplicator;
}

export function toLocaleNumber(x) {
  let parts = x.toString().split(".");
  parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  return parts.join(",");
}



// WEBPACK FOOTER //
// ./assets/javascripts/helpers/math_helper.js